import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { PatchTaskModel } from "models/PatchTaskModel";
import { SiveActionResult } from "models/SiveActionResult";
import { TaskModel } from "models/TaskModel";

export class TasksApi {
  constructor(private axios: AxiosInstance) {}

  async find(filter: string) {
    const url = getBoardApiUrl(`tasks/find/${filter}`);
    const response = await this.axios.get<TaskModel[]>(url);
    return response.data;
  }

  async getItem(taskId: number) {
    if (!taskId) throw new Error("taskId is required");
    const url = getBoardApiUrl(`tasks/${taskId}`);
    const response = await this.axios.get<TaskModel>(url);
    return response.data;
  }

  async getAgendaItemTasks(meetingId: number, agendaItemId: number) {
    if (!meetingId) throw new Error("MeetingId is required");
    if (!agendaItemId) throw new Error("AgendaItemId is required");
    const url = getBoardApiUrl(`tasks/meeting/${meetingId}/${agendaItemId}`);
    const response = await this.axios.get<TaskModel[]>(url);
    return response.data;
  }

  async addToMeeting(patch: PatchTaskModel) {
    const { meetingId, agendaItemId } = patch;
    if (!meetingId) throw new Error("MeetingId is required");
    if (!agendaItemId) throw new Error("AgendaItemId is required");
    const url = getBoardApiUrl(`tasks/meeting/${meetingId}/${agendaItemId}`);
    const response = await this.axios.post<SiveActionResult>(url, patch);
    return response.data;
  }

  async delete(taskId: number) {
    if (!taskId) throw new Error("taskId is required");
    const url = getBoardApiUrl(`tasks/${taskId}`);
    const response = await this.axios.delete<SiveActionResult>(url);
    return response.data;
  }

  async update(patch: PatchTaskModel) {
    const { id: taskId } = patch;
    if (!taskId) throw new Error("taskId is required");
    const url = getBoardApiUrl(`tasks/${taskId}`);
    const response = await this.axios.patch<SiveActionResult>(url, patch);
    return response.data;
  }

  async closeTask(taskId: number) {
    if (!taskId) throw new Error("taskId is required");
    const url = getBoardApiUrl(`tasks/close/${taskId}`);
    const response = await this.axios.patch<SiveActionResult>(url);
    return response.data;
  }
}
